(() => {
  const monthPattern = /\b(january|february|march|april|may|june|july|august|september|october|november|december)\b/i;

  function setupChoices(choices) {
    if (choices.dataset.initialized === 'true') return;
    choices.dataset.initialized = 'true';

    const form = choices.closest('form');
    const variantInput = form?.querySelector('input[name="id"]');
    const shellInput = choices.querySelector('input[name="properties[Shell color]"]');
    const pearlInput = choices.querySelector('input[name="properties[Glass pearl color]"]');
    const birthstoneInput = choices.querySelector('input[name="properties[Birth month and birthstone]"]');
    const pearlField = choices.querySelector('[data-ll-pearl-field]');
    const birthstoneField = choices.querySelector('[data-ll-birthstone-field]');
    const paymentButton = form?.querySelector('.shopify-payment-button');

    if (!form || !variantInput || !shellInput || !pearlInput || !birthstoneInput) return;

    function isBirthstoneSelected() {
      return Boolean(choices.dataset.birthstoneVariantId) &&
        variantInput.value === choices.dataset.birthstoneVariantId;
    }

    function birthstonePairIsComplete() {
      const value = birthstoneInput.value.trim();
      if (!monthPattern.test(value)) return false;
      return value.replace(monthPattern, '').replace(/[\d\s.,:+\-–—/|()]/g, '').length >= 2;
    }

    function activeDetailInput() {
      return isBirthstoneSelected() ? birthstoneInput : pearlInput;
    }

    function choicesAreComplete() {
      return Boolean(shellInput.value.trim()) &&
        (isBirthstoneSelected() ? birthstonePairIsComplete() : Boolean(pearlInput.value.trim()));
    }

    function updateCheckoutGuard() {
      if (!paymentButton) return;
      const incomplete = !choicesAreComplete();
      paymentButton.classList.toggle('ll-tidepool-checkout-locked', incomplete);
      paymentButton.setAttribute('aria-disabled', String(incomplete));
    }

    function validateChoices() {
      shellInput.setCustomValidity(shellInput.value.trim() ? '' : 'Please enter your shell color.');
      if (!shellInput.checkValidity()) {
        shellInput.reportValidity();
        shellInput.focus();
        return false;
      }

      const detailInput = activeDetailInput();
      if (isBirthstoneSelected()) {
        detailInput.setCustomValidity(
          birthstonePairIsComplete() ? '' : 'Please enter both a birth month and a birthstone, for example October — Opal.'
        );
      } else {
        detailInput.setCustomValidity(detailInput.value.trim() ? '' : 'Please enter your glass pearl color.');
      }
      if (!detailInput.checkValidity()) {
        detailInput.reportValidity();
        detailInput.focus();
        return false;
      }
      return true;
    }

    function syncVariant() {
      const birthstoneSelected = isBirthstoneSelected();
      pearlField.hidden = birthstoneSelected;
      pearlInput.disabled = birthstoneSelected;
      pearlInput.setCustomValidity('');
      birthstoneField.hidden = !birthstoneSelected;
      birthstoneInput.disabled = !birthstoneSelected;
      birthstoneInput.setCustomValidity('');
      updateCheckoutGuard();
    }

    [shellInput, pearlInput, birthstoneInput].forEach((input) => {
      input.addEventListener('input', () => {
        input.setCustomValidity('');
        updateCheckoutGuard();
      });
      input.addEventListener('change', updateCheckoutGuard);
    });

    variantInput.addEventListener('change', syncVariant);
    form.addEventListener('submit', (event) => {
      if (validateChoices()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    // Accelerated checkout buttons can be rendered in an iframe, so the CSS
    // overlay keeps them unavailable until the required choices are complete.
    paymentButton?.addEventListener('pointerdown', updateCheckoutGuard, true);
    paymentButton?.addEventListener('click', (event) => {
      updateCheckoutGuard();
      if (choicesAreComplete()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      validateChoices();
    }, true);

    window.addEventListener('pageshow', updateCheckoutGuard);
    syncVariant();
  }

  function setupAll(root = document) {
    root.querySelectorAll('[data-ll-tidepool-choices]').forEach(setupChoices);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll(), { once: true });
  } else {
    setupAll();
  }
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
